<template>
	<div class="talent-tab">
		<el-alert title="关联达人的数据统计不包含当日的数据" type="warning" show-icon :closable="false" />
		<div class="flex flex-align-center mt-12" v-if="$auth.hasPermi('system:cooperativeColonel:addTalent')">
			<el-button type="primary" plain @click="showAddTalentDialog">添加关联达人</el-button>
			<div class="fz-14 yx-color-info ml-16">
				<span>共</span>
				<span class="yx-color-text-primary font-bold">{{ total }}</span>
				<span>个关联达人</span>
			</div>
		</div>
		<multi-table
			v-show="total"
			ref="multiTable"
			:distanceTop="0"
			:pageFixed="false"
			:columns="columns"
			@gePartnerList="gePartnerList"
			:list="list"
			:total="total"
			v-loading="loading"
		></multi-table>
		<div class="align-center" style="margin-top: 150px" v-if="total == 0">
			<div class="i-empty"></div>
			<div class="yx-color-info">暂无数据</div>
		</div>
		<add-talent-dialog ref="addTalentDialog" @getList="getInfo" />
		<add-ks-talent-dialog ref="addKsTalentDialog" @getList="getInfo" />
	</div>
</template>

<script>
import addTalentDialog from '@/views/secondColonelManage/cooperativeColonel/components/addTalentDialog';
import addKsTalentDialog from '@/views/secondColonelManage/cooperativeColonel/components/addKsTalentDialog';
import { getInstitutionInstitutionList } from '@/api/secondColonelManage';
import { columns } from './columns.js';
export default {
	name: 'talentTab',
	props: {
		id: {
			type: [String, Number],
			default: 0,
		},
		platformId: {
			type: [String, Number],
			default: dataMap.PLATFORM_DY.value,
		},
		institutionName: {
			type: String,
			default: '',
		},
	},
	components: {
		addTalentDialog,
		addKsTalentDialog,
	},
	data() {
		return {
			list: [],
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			columns,
			loading: false,
		};
	},
	methods: {
		async getInfo() {
			const { pageInfo, id: team_institution_id } = this;
			this.loading = true;
			try {
				const { code, data: { list = [], page = {} } = {} } = await getInstitutionInstitutionList({ ...pageInfo, team_institution_id });
				if (code !== 0) return;
				this.list = list;
				this.total = page.item_total;
			} finally {
				this.loading = false;
			}
		},
		gePartnerList({ page_index, page_size }) {
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getInfo();
		},
		showAddTalentDialog() {
			const ref = {
				[dataMap.PLATFORM_DY.value]: 'addTalentDialog',
				[dataMap.PLATFORM_KS.value]: 'addKsTalentDialog',
			};
			this.$refs[ref[this.platformId]].show(this.id, this.institutionName);
		},
	},
};
</script>

<style lang="less" scoped>
.talent-tab {
	margin-top: 10px;

	.talent-info {
		display: flex;

		.right {
			margin-left: 8px;
			font-size: 14px;
			color: #666;
			flex: 1;
			overflow: hidden;

			.ellipsis {
				color: #333;
			}

			.number {
				display: flex;
				align-items: center;

				.ellipsis {
					margin-left: 8px;
					flex: 1;
					overflow: hidden;
					color: #666;
				}
			}
		}
	}
}
</style>
